module.exports = __webpack_public_path__ + "img/1.4b0b6f9e.jpg";